import { Modal, Button, Group, Text, Stack, Box, useMantineColorScheme, LoadingOverlay } from '@mantine/core';

interface ConfirmationModalProps {
    opened: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title?: string;
    children: React.ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmColor?: string;
    loading?: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    opened,
    onClose,
    onConfirm,
    title = "Confirm Action",
    children,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    confirmColor = "blue",
    loading = false
}) => {
    const { colorScheme } = useMantineColorScheme();

    return (
        <Modal 
            opened={opened} 
            onClose={onClose} 
            title={title} 
            centered
            overlayProps={{ backgroundOpacity: 0.1, blur: 2 }}
        >
            <LoadingOverlay visible={loading} overlayProps={{ blur: 2 }} />
            <Stack gap="lg">
                <Box
                    p="md"
                    style={{
                        border: '1px solid var(--modal-border)',
                        borderRadius: 'var(--mantine-radius-md)',
                        background: colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.01)' : 'rgba(255, 255, 255, 0.5)',
                        backdropFilter: colorScheme === 'light' ? 'blur(10px)' : undefined
                    }}
                >
                    <Text size="sm">{children}</Text>
                </Box>

                <Group justify="flex-end" pt="sm">
                    <Button variant="subtle" color="gray" onClick={onClose} disabled={loading}>
                        {cancelLabel}
                    </Button>
                    <Button 
                        color={confirmColor === 'blue' ? 'black' : confirmColor} 
                        c={confirmColor === 'blue' ? 'white' : undefined}
                        onClick={onConfirm} 
                        loading={loading}
                    >
                        {confirmLabel}
                    </Button>
                </Group>
            </Stack>
        </Modal>
    );
};
